var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.Icon,{attrs:{"name":`${_vm.icon}_icon`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }